import Link from 'next/link';
import Image from 'next/image';
import React from 'react';

const LogoHeader = () => {
  return (
    <div className={`header`}>
      <Link prefetch={false} href='/' className='header__logo'>
        <Image
          className='small-logo-img'
          src='/static/imgs/logo/tud-logo-horizontal.png'
          alt='The Urban Developer'
          width={400}
          height={45}
        />
      </Link>
      <Link
        prefetch={false}
        href='/'
        className='header__logo--mobile'
        title='The Urban Developer'
      >
        <Image
          className='small-logo-img'
          src='/static/imgs/logo/tud-logo-graphic.png'
          alt='The Urban Developer'
          width={45}
          height={45}
        />
      </Link>
    </div>
  );
};

export default LogoHeader;
